import Modal from "../../../../components/Modal";
import FormInput from "../../../../components/FormInput";
import Button from "../../../../components/Button";
import Dropdown from "../../../../components/Dropdown";
// Remove the import line for fridgeImg since we're using public folder path
import styles from "../css/ecoControlFridges.module.css";

export default function FridgeDetailsModal({
  showDetails,
  selectedFridge,
  detailsEdit,
  dBin,
  dTemp,
  dTotalQty,
  dSupplier,
  dSerial,
  detailsRange,
  detailsWeekday,
  onClose,
  onEdit,
  onSave,
  onCancel,
  onBinChange,
  onTempChange,
  onTotalQtyChange,
  onSupplierChange,
  onSerialChange,
  onRangeChange,
  onWeekdayChange,
  onReset
}) {
  if (!showDetails) return null;

  return (
    <Modal onClose={() => { onClose(); if (detailsEdit) onReset(); }}>
      <div className={styles.detailsWrap}>
        <h2 className={styles.detailsTitle}>{selectedFridge?.name?.replace('Fridge', 'Fridge')}</h2>
        <div className={styles.detailsGrid}>
          <div className={styles.detailsLeft}>
            <FormInput label="Bin Number" name="bin" value={dBin} onChange={detailsEdit ? onBinChange : undefined} />
            <FormInput label="Temperature °C" name="temp" value={dTemp} onChange={detailsEdit ? onTempChange : undefined} />
            <FormInput label="Total Quantity" name="totalQty" value={dTotalQty} onChange={detailsEdit ? onTotalQtyChange : undefined} />
            <FormInput label="Supplier" name="supplier" value={dSupplier} onChange={detailsEdit ? onSupplierChange : undefined} />
            <FormInput label="Fridge Serial Number" name="serial" value={dSerial} onChange={detailsEdit ? onSerialChange : undefined} />
            <div className={styles.detailsButtons}>
              {!detailsEdit ? (
                <>
                  <Button variant="primary" onClick={onEdit}>Edit</Button>
                  <Button variant="secondary" onClick={onClose}>Close</Button>
                </>
              ) : (
                <>
                  <Button
                    variant="primary"
                    onClick={onSave}
                  >
                    Save
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </div>
          </div>
          <div className={styles.detailsCenter}>
            <img src="/images/SmartFridge.jpg" alt={selectedFridge?.name || 'Fridge'} className={styles.detailsImage} />
          </div>
          <div className={styles.detailsRight}>
            <div className={styles.filtersRow}>
              <Dropdown name="range" options={["Day","Week","Month"]} value={detailsRange} onChange={onRangeChange} />
              <Dropdown name="weekday" options={["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"]} value={detailsWeekday} onChange={onWeekdayChange} />
            </div>
            <div className={styles.legendRow}>
              <span className={styles.legendDot} />
              <span>Temperature °C</span>
            </div>
            <svg className={styles.tempChart} viewBox="0 0 600 220" preserveAspectRatio="none">
              <line x1="40" y1="10" x2="40" y2="200" stroke="#111"/>
              <line x1="40" y1="200" x2="590" y2="200" stroke="#111"/>
              <polyline fill="none" stroke="#6366f1" strokeWidth="3" points="40,180 160,180 280,200 400,180 520,180"/>
              <text x="60" y="215" fontSize="12">00:00</text>
              <text x="180" y="215" fontSize="12">01:00</text>
              <text x="300" y="215" fontSize="12">02:00</text>
              <text x="420" y="215" fontSize="12">03:00</text>
              <text x="540" y="215" fontSize="12">04:00</text>
            </svg>
            <div className={styles.warningBanner}>
              <span className={styles.warnIcon}>!</span>
              <div>
                <div className={styles.warnTitle}>Warning</div>
                <div className={styles.warnSub}>Temperature drop</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

